
export default {
  performance: [],
  tabs: [], // 绩效列表Tab指标
  current: 0,
  filters: {
    // 非必需
    indicatorId: 0, // 指标ID.All tab不传，其他tab必传
    shopId: 0, // 商家ID
    shopName: '', // 商家名称
    rank: [], // 商机等级
    shopLayerLevel: [], // 商家运营等级
    potential: [],
    rPerformance: [],
    // 必需
    shopRange: 1, // 商家范围 1未达标商家 2全部商家
    storeType: 'shopName', // Store Name下拉列表
    sort: 1, // 排序 1系统推荐 2距离排序
    pageNo: 1, // 页码
    pageSize: 20, // 默认20
    lat: 0, // 纬度
    lng: 0 // 经度

  },
  perfDetail:{}
}
